import config from "../../../server/config";
import { isValidArray } from "./index";

/**
 * Find the external URL a path must be redirected to, if any.
 *
 * @param {string} url - path to evaluate against config.vanitiesURL
 * @returns {string|null}
 */
export function getVanityRedirectURL(url) {
  const { vanitiesURL } = config;
  if (!url || !isValidArray(vanitiesURL)) {
    return null;
  }
  const vanity = vanitiesURL.find(v =>
    new RegExp(Object.keys(v).pop()).test(url)
  );
  return !!vanity ? Object.values(vanity).pop() : null;
}

export function validateVainitiesURL(req, res) {
  if (req !== null) {
    const urlToRedirect = getVanityRedirectURL(req.url);
    if (!!urlToRedirect) {
      res.writeHead(301, {
        Location: urlToRedirect
      });
      res.end();
    }
  }
}
